import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { setUserData, setPermissions } from './redux/emp'; 
import Spinner from './components/ogComponent/spinner';

export default function Protected({ children }) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchPermissions = async (accessToken) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/api/common/allowed-menus/`, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      // Extract IDs from the response and dispatch to Redux
      const permissionIds = response.data.map(menu => menu?.menu_program_id);
      dispatch(setPermissions(permissionIds));
    } catch (error) {
      console.error('Error fetching permissions:', error);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('accessToken');
        navigate('/login');
      }
    }
  };

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    
    if (!accessToken) {
      navigate('/login');
      return;
    }

    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}/api/account/users-profile/`, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        });
        dispatch(setUserData(response.data));
        
        // Fetch permissions after successful user data fetch
        await fetchPermissions(accessToken);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching user data:', error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('accessToken');
          navigate('/login');
        }
      }
    };

    fetchUserData();

    // Set up interval to refresh permissions every 30 minutes
    const intervalId = setInterval(() => {
      if (accessToken) {
        fetchPermissions(accessToken);
      }
    }, 30 * 60 * 1000); // 30 minutes in milliseconds

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [navigate, dispatch]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      {children}
    </>
  );
}